function omit(object, omissible) {
  const filtered = {};
  Object.keys(object).forEach(key => {
    if (!omissible.includes(key)) {
      filtered[key] = object[key];
    }
  });
  return filtered;
}

export { omit };
